
<script>
import spinner from './spinner';

export default {
  methods: {
    handleClick (evt) {
      // console.log(this.disabled);
      if (this.disabled) {
        return;
      }

      if (this.to && this.$router) {
        this.$router.push(this.to);
      }

      this.$emit('click', evt);
    }
  },

  // components: {
  //   spinner
  // },

  props: {
    icon: String,
    disabled: Boolean,
    href: String,
    target: String,
    to: [String, Object],
    nativeType: {
      type: String,
      default: 'button'
    },
    plain: Boolean,
    round: Boolean,
    text: Boolean,
    loading: Boolean,
    type: {
      type: String,
      default: 'default',
      validator (value) {
        return [
          'default',
          'danger',
          'primary',
          'text'
        ].indexOf(value) > -1;
      }
    },
    size: {
      type: String,
      default: 'normal',
      validator (value) {
        return [
          'small',
          'normal',
          'large'
        ].indexOf(value) > -1;
      }
    }
  },

  render (h) {
    let tag = 'button';
    let Icon = null;
    let Spinner = null;
    let domProps = {
      disabled: this.disabled || this.loading
    };

    if (this.href) {
      tag = 'a';
      domProps.href = this.href;
      domProps.target = this.target;
    } else {
      domProps.type = this.nativeType;
    }

    if (this.loading) {
      Spinner = h(spinner, {
        props: {
          show: true,
          stroke: '#fff'
        }
      });
    }

    if (this.$slots.icon) {
      Icon = h('span', {
        'class': {
          'hsb-button-icon': true
        }
      }, [this.$slots.icon]);
    }

    const Label = h('label', {
      'class': {
        'hsb-button-text': true
      }
    }, [this.$slots.default]);

    return h(tag, {
      'class': ['hsb-button--' + this.type, 'hsb-button--' + this.size, {
        'is-disabled': this.disabled,
        'is-plain': this.plain,
        'is-round': this.round,
        'is-loading': this.loading,
        'is-href': !!this.href,
        'hsb-button': true
      }],
      domProps,
      on: {
        click: this.handleClick
      }
      // nativeOn: {
      //   click: this.handleClick
      // }
    }, [
      Icon,
      Spinner,
      Label
    ]);
  }
};
</script>

<style lang="css">
  @import "config.css";

  .hsb-button {
    appearance: none;
    border-radius: $global-border-radius;
    border: 0;
    box-sizing: border-box;
    display: inline-block;
    height: 41px;
    outline: 0;
    overflow: hidden;
    position: relative;
    text-align: center;
    cursor: pointer;
    vertical-align: middle;
    line-height: 1;

    &.is-href {
      line-height: 40px;
    }

    &::after {
      background-color: #000;
      content: " ";
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }

    &:not(.is-disabled):active::after {
      opacity: .4;
    }

    &.is-disabled, &[disabled] {
      background-color: $global-disabled-bgc;
      cursor: not-allowed;
    }

    &.is-round {
      border-radius: 20px;
    }
  }

  .hsb-button-text {
    vertical-align: middle;
  }

  .hsb-button-icon {
    vertical-align: middle;
    display: inline-block;
  }

  .hsb-button--default {
    color: $global-base-color;
    background-color: $global-gray;

    &.is-plain {
      border: 1px solid $global-base-color;
      background-color: transparent;
      box-shadow: none;
      color: $global-base-color;
    }
  }

  .hsb-button--primary {
    color: #fff;
    background-color: $global-primary-color;

    &.is-plain {
      border: 1px solid $global-primary-color;
      background-color: transparent;
      color: $global-primary-color;
    }
  }

  .hsb-button--danger {
    color: $global-white;
    background-color: $global-danger-color;

    &.is-plain {
      border: 1px solid $global-danger-color;
      background-color: transparent;
      color: $global-danger-color;
    }
  }

  .hsb-button--large {
    display: block;
    width: 100%;
    padding: 0 32px;
    height: $button-large-height;
  }

  .hsb-button--normal {
    display: inline-block;
    padding: 0 24px;
  }

  .hsb-button--small {
    display: inline-block;
    font-size: 14px;
    padding: 0 16px;
    height: 30px;
  }

  .hsb-button--text {
    background-color: $global-danger-color;
    border-color: transparent;
    background: transparent;
    padding-left: 0;
    padding-right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/button.vue